export const ACCESS_LEGITIMATE_CMS = "access-legitimate-cms";
